import { useEffect } from 'react';
import {
  useConsultationsFeatureEnabled,
  useLoyaltyFeatureEnabled,
  useOnlineOrdersFeatureEnabled,
} from '../../data/domains/config';
import { useExitOrGoBack } from './useAuthNavigation';

/** When a feature flag is off, exit the current screen (deep links / stale nav). */
export function useFeatureGateExit(enabled: boolean, on_exit: () => void): boolean {
  useEffect(() => {
    if (!enabled) {
      on_exit();
    }
  }, [enabled, on_exit]);
  return enabled;
}

export function useRequireOnlineOrdersEnabled(): boolean {
  const enabled = useOnlineOrdersFeatureEnabled();
  const on_exit = useExitOrGoBack();
  return useFeatureGateExit(enabled, on_exit);
}

export function useRequireConsultationsEnabled(): boolean {
  const enabled = useConsultationsFeatureEnabled();
  const on_exit = useExitOrGoBack();
  return useFeatureGateExit(enabled, on_exit);
}

export function useRequireLoyaltyEnabled(): boolean {
  const enabled = useLoyaltyFeatureEnabled();
  const on_exit = useExitOrGoBack();
  return useFeatureGateExit(enabled, on_exit);
}
